import { TranslateService } from '@ngx-translate/core';
import { SALES_INSIGHTS_DIM_PREFIX } from '../models/sales-insights.model';

export function salesInsightsFilterLabel(translate: TranslateService, filter: string): string {
  if (!filter.startsWith(SALES_INSIGHTS_DIM_PREFIX)) {
    return translate.instant(`SALES_INSIGHTS_FILTER_${filter.toUpperCase()}`);
  }
  const name = filter.substring(SALES_INSIGHTS_DIM_PREFIX.length);
  const key = `SALES_INSIGHTS_DIM_${name.toUpperCase()}`;
  const translated = translate.instant(key);
  return translated === key ? name.charAt(0).toUpperCase() + name.slice(1) : translated;
}

export function salesInsightsLocale(translate: TranslateService): string {
  const lang = translate.currentLang || translate.defaultLang;
  return lang === 'se' || lang === 'sv' ? 'sv-SE' : lang || 'en-GB';
}

export function salesInsightsMonthYear(translate: TranslateService, yearMonth: string): string {
  const match = /^(\d{4})-(\d{2})/.exec(yearMonth);
  if (!match) {
    return yearMonth;
  }
  return new Date(+match[1], +match[2] - 1, 1).toLocaleDateString(salesInsightsLocale(translate), {
    month: 'long',
    year: 'numeric'
  });
}

export function salesInsightsNoValueLabel(translate: TranslateService, groupBy: string | undefined): string {
  const key = `SALES_INSIGHTS_NO_VALUE_${(groupBy || '').replace(/\./g, '_').toUpperCase()}`;
  const translated = groupBy ? translate.instant(key) : key;
  return translated === key ? translate.instant('SALES_INSIGHTS_NO_VALUE') : translated;
}
